/**
 * `orange-app-info` local storage entry, written by the Orange native app before loading the webview
 */
export interface OrangeAppInfo {
    name?: string;
    version?: string;
    os?: string;
    'os-ver'?: string;
}

/**
 * Entry properties, ordered as they must appear in the `x-orange-app-info` header
 */
export const ORANGE_APP_INFO_PROPERTIES: (keyof OrangeAppInfo)[] = ['name', 'version', 'os', 'os-ver'];
